import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
import './i18n';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga4';

if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
	ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}

const root = createRoot(document.getElementById('root'));
root.render(
	<Router
		basename={process.env.PUBLIC_URL}
	>
		<React.StrictMode>
			<Provider store={store}>
				<ThemeContextProvider>
					<App />
				</ThemeContextProvider>
			</Provider>
		</React.StrictMode>
	</Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
